import {Component, OnInit} from '@angular/core';
import {Project} from '../../data/project/project';
import {ConfirmationService} from 'primeng/api';
import {ProjectService} from '../../data/project/project.service';
import {KanbanBoardStore} from 'projects/desktop/src/app/modules/kanban-board/data/kanban-board.store';
import {MvcExceptionResponse} from 'projects/core/src/lib/core/data/mvc-exception-response';
import {ProjectHolder} from '../../interfaces/project-holder';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {User} from 'projects/core/src/lib/login/data/user';
import {AppStateQuery} from 'projects/desktop/src/app/data/app-state.query';
import {DropboxChooser} from './dropbox/dropbox-chooser';
import {DropboxChooserResult} from './dropbox/dropbox-chooser-result';
import {LabelsPrintDialogComponent} from './labels-print-dialog/labels-print-dialog.component';
import {environment} from 'projects/desktop/src/environments/environment';
import {EstimateDialogComponent} from '../../../qb/view/estimate-dialog/estimate-dialog.component';
import {PdfPreviewDialogComponent} from '../pdf-preview-dialog/pdf-preview-dialog.component';
import {getActivityDateAndReady} from '../../public-api';
import {
  ToggleCabinetsStatusComponent
} from '../../../cabinets/view/toggle-cabinets-status/toggle-cabinets-status.component';
import {EnvelopsDialogComponent} from '../../../docusign/view/envelops-dialog/envelops-dialog.component';
import {DocusignService} from 'projects/app-misc/src/app/modules/docusign/data/docusign.service';
import {DomSanitizer} from '@angular/platform-browser';
import {ShortProject} from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';
import {
  ProjectCopyDialogComponent
} from 'projects/app-misc/src/app/modules/project-misc/view/project-panel/project-copy-dialog/project-copy-dialog.component';
import {Router} from '@angular/router';
import {ProjectCalcService} from '../../../project-calc/data/project-calc.service';
import {RouterService} from "../../../../../../../core/src/lib/misc/router/router.service";


@Component({
  selector: 'app-project-panel',
  templateUrl: './project-panel.component.html',
  styleUrls: ['./project-panel.component.scss'],
  providers: [ConfirmationService]
})
export class ProjectPanelComponent implements OnInit {

  project: Project;

  dropBoxLoading: boolean;
  dropBoxSyncLoading: boolean;

  seattleProdLoading: boolean;
  systemState = environment.systemState

  dropBoxLink: string;
  docusignLoading: boolean;

  scanLoading: boolean;

  projectDeleteLoading: boolean;

  currentUser: User;

  constructor(
    private routerService: RouterService,
    public router: Router,
    private sanitizer: DomSanitizer,
    protected projectCalcService: ProjectCalcService,
    protected docusignService: DocusignService,
    protected projectHolder: ProjectHolder,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    protected kanbanBoardStore: KanbanBoardStore,
    protected confirmationService: ConfirmationService,
    protected projectService: ProjectService,
    protected appStateQuery: AppStateQuery
  ) {
  }

  ngOnInit() {
    this.project = this.projectHolder.project;

    this.getDropboxLink();

    this.getCurrentUser();
  }

  getCurrentUser() {
    this.appStateQuery.currentUser$.subscribe(user => {
      this.currentUser = user
    })
  }

  deleteProject() {
    this.confirmationService.confirm({
      header: 'Delete Project?',
      message: `Delete ${this.project.name}?`,
      accept: () => {
        this.projectDeleteLoading = true;
        this.projectService
          .deleteProject(this.project.id)
          .subscribe(() => {
              this.project.id = -1;

              this.dialog.closeAll();
              this.projectDeleteLoading = false;
            },
            error => {
              if (error instanceof MvcExceptionResponse) {
                if (error.type === 'project.ProjectException') {
                  this.openSnackBar(error.message)
                }
              }
              this.projectDeleteLoading = false;
            })
      }
    });
  }

  disableCVSync() {
    this.confirmationService.confirm({
      header: 'Delete CV Sync?',
      message: `Delete CV Data For ${this.project.name}?`,
      accept: () => {
        this.projectService
          .deleteProjectCVSync(this.project.id)
          .subscribe(() => {
              this.openSuccessSnackBar('Success!')
            },
            error => {
              if (error instanceof MvcExceptionResponse) {
                if (error.type === 'project.ProjectException') {
                  this.openSnackBar(error.message)
                }
              }
            })
      }
    });
  }

  getDropboxLink() {
    this.dropBoxLoading = true;

    this.projectService.getProjectDropBoxLink(this.project.id).subscribe(link => {
      this.dropBoxLink = link.path;
      this.dropBoxLoading = false;
    })
  }

  openDropbox() {
    this.dropBoxLoading = true;
    const windowReference = window.open();

    this.projectService.getProjectDropBoxLink(this.project.id).subscribe(link => {
      this.dropBoxLink = link.path;
      this.dropBoxLoading = false;

      windowReference.location.assign('https://www.dropbox.com/home' + this.dropBoxLink);
    })

  }

  changeDropboxPath() {
    // tslint:disable-next-line: no-string-literal
    (window['Dropbox'] as DropboxChooser).choose({
      linkType: 'preview',
      folderselect: true,
      success: (files: DropboxChooserResult[]) => {
        if (files[0].isDir) {
          this.projectService.changeDropboxPath(this.project.id, {
            id: files[0].id,
            path: ''
          }).subscribe(() => {
            this.openSuccessSnackBar('Path successfully changed!')
            this.getDropboxLink();
          })
        }
      },
      cancel: () => {
        // this.showHint(info);
      },

    })
  }

  syncDropBox() {
    this.dropBoxSyncLoading = true;

    this.projectService.syncDropboxPath(this.project.id).subscribe(() => {
      this.dropBoxSyncLoading = false;
    })
  }


  openEstimates() {
    const dialogRef = this.dialog.open(EstimateDialogComponent, {
      data: this.project.id,
      panelClass: 'estimates-modal-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  openMaterialsReport() {
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/materials/report',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
    cpDialogRef.afterOpened().subscribe(() => {
    })
    cpDialogRef.afterClosed().subscribe(() => {
    })
  }

  printLabels() {
    const dialogRef = this.dialog.open(LabelsPrintDialogComponent, {
      data: {
        id: this.project.id,
        name: this.project.name
      },
      panelClass: 'labels-modal-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result === 'Success!') {
        this.openSuccessSnackBar('Success!')
      }
    });
  }

  sendToProd() {

    this.confirmationService.confirm({
      header: 'Send to PRODUCTION?',
      icon: 'pi pi-info-circle',
      message: `This action will send the current project in to production, please ensure all drawings and proposals are approved, would you like to send to production?`,
      accept: () => {
        this.seattleProdLoading = true;

        this.projectService.sendToSeattleProd(this.project.id).subscribe(() => {
          this.project.migratedBy = this.currentUser;
          this.project.migratedDate = new Date()

          this.seattleProdLoading = false;
          this.openSuccessSnackBar('Success!')
        }, () => {
          this.seattleProdLoading = false;
          this.openSnackBar('Something went wrong!')
        })
      }
    });

  }


  openPdfLabels(): void {
    // this.sendData.emit(this.currentUser)
    const cpDialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: this.project.name,
        link: '/project/' + this.project.id + '/label',
        showSendButton: true
      },
      panelClass: 'pdf-preview-dialog'
    });
    cpDialogRef.afterOpened().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'none')
    })
    cpDialogRef.afterClosed().subscribe(() => {
      // this.renderer.setStyle(this.viewContainerRef.element.nativeElement, 'display', 'flex')
    })
  }

  openProjectPricing() {
    this.projectService.getShortPricingByProjectId(this.project.id).subscribe(pricingId => {
      this.projectCalcService.lastChosenPricingSubj.next(null)

      this.routerService.routeTo('/pricing/' + pricingId)
      this.dialog.closeAll();
    })
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 7000,
      verticalPosition: 'top',
      panelClass: 'error-snackbar',
    });
  }

  openSuccessSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 7000,
      verticalPosition: 'top',
      panelClass: 'success-snackbar',
    });
  }


  openCabinetsToggleStatusDialog(activityType: string): void {
    const activityStatus = getActivityDateAndReady(this.project, activityType);

    this.dialog.open(ToggleCabinetsStatusComponent, {
      data: {
        project: this.project,
        activityType,
        activityStatus
      },
      panelClass: 'cabinets-toggle-status-dialog'
    });

  }

  openDocu() {
    const w = window.innerWidth * 0.70;
    const h = window.innerHeight * 0.70;

    const windowFeatures = `left=100,top=100,width=${w},height=${h},popup`;

    this.docusignLoading = true;
    const windowReference = window.open('', '', windowFeatures);

    this.docusignService.getEditorUrl(this.project.id).subscribe(info => {
      this.dropBoxLink = info.url;
      this.docusignLoading = false;

      windowReference.location.assign(this.dropBoxLink);
    })
  }

  openEnvelopes() {
    const dialogRef = this.dialog.open(EnvelopsDialogComponent, {
      data: {
        projectNumber: this.project.id,
        projectName: this.project.name
      },
      panelClass: 'envelopes-modal-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  openCopyProjectDialog() {
    const cpDialogRef = this.dialog.open(ProjectCopyDialogComponent, {
      data: {
        project: {
          id: this.project.id,
          name: this.project.name,
          number: this.project.number
        } as ShortProject
      },
      panelClass: 'project-copy-dialog'
    });
    cpDialogRef.afterClosed().subscribe(() => {

    });
  }


}
